<script setup lang="ts">
import { computed } from 'vue';

import type { IAffiliatesTableDataResponseRecord } from '@modules/affiliates-approved/types';
import type { ITableDataResponse } from '@modules/tables/types';
import { AFFILIATES_LIST_QUERY_KEY } from '@modules/affiliates-approved/constants';
import { useAffiliatesListQuery } from '@modules/affiliates-approved/queries';
import VAffiliateProfileUpdateForm from '@modules/affiliates-approved/submodules/affiliate-profile/components/VAffiliateProfileUpdateForm/VAffiliateProfileUpdateForm.vue';
import { useAffiliateProfileUpdate } from '@modules/affiliates-approved/submodules/affiliate-profile/composables';
import {
  AFFILIATES_APPROVED_PROFILE_PERMISSIONS,
} from '@modules/affiliates-approved/submodules/affiliate-profile/constants';
import { useTableData } from '@modules/tables/composables';
import { useQueryClient } from '@tanstack/vue-query';

import { TRANSLATION_GROUP_AFFILIATE_PROFILE_GENERAL } from '../../constants';

const queryClient = useQueryClient();

const queryData = queryClient.getQueryData<ITableDataResponse<IAffiliatesTableDataResponseRecord>>([AFFILIATES_LIST_QUERY_KEY, { page: 1 }]);

const { data } = useTableData(useAffiliatesListQuery, !queryData);

const isStatusColumnEnabled = computed<boolean>(() => !!(
  (queryData?.columns_for_display_data ?? data.value?.columns_for_display_data)?.find((column) => column.name === 'status')
));

const {
  formGeneralSchema,
  profileErrors,
  isOptionsLoading,
  isProfileUpdateLoading,
  clearProfileError,
  onSubmitGeneral,
  onChange,
} = useAffiliateProfileUpdate(TRANSLATION_GROUP_AFFILIATE_PROFILE_GENERAL, isStatusColumnEnabled);
</script>

<template>
  <VAffiliateProfileUpdateForm v-data-qa-auto-id="'ProfileGeneralPage'"
    :form-schema="formGeneralSchema"
    :errors="profileErrors"
    :readonly="!$hasPermission(AFFILIATES_APPROVED_PROFILE_PERMISSIONS.EDIT)"
    :is-data-loading="isOptionsLoading"
    :is-update-loading="isProfileUpdateLoading"
    @change="onChange"
    @submit="onSubmitGeneral"
    @interacted="clearProfileError"
  />
</template>
